export const apiConstants = {
  branches: '/branches',
};
